import { Stack } from '@mui/system'

type Props = {
  children: React.ReactNode
}

export default function VehicleNavigator({ children }: Props) {
  return <Stack spacing={1}>{children}</Stack>
}
